export default __webpack_public_path__ + "static/media/SAICE-Education-Training-gold.458487d4.png";